import styled from 'styled-components';

export const Container = styled.div.attrs({
    className: 'datetabpicker'
})`
display: flex;
justify-content: center;
background: #EEEEEE80;
border-bottom: 1px solid #36383d;
`;

export const Tab = {
    
    Main: styled.div.attrs({
        className: 'datetabpicker-tab'
    })`
    width: 13%;
    text-align: center;
    text-transform: uppercase;
    padding: 10px 35px 6px 35px;
    border-left: 1px solid #EEEEEE80;
    border-right: 1px solid #EEEEEEFF;
    border-bottom: 4px solid transparent;
    user-select: none;

    &:hover {
        cursor: pointer;
        background: #EEEEEEFF;
    }

    &:nth-of-type(5){
        background-color: #36383d;
        color: #fec920;
        font-weight: 500;
    }
    `,

    Arrow: styled.div.attrs({
        className: 'datetabpicker-arrow'
    })`
    width:4.5%;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
        cursor: pointer;
        background: #EEEEEEFF;
    }
    `,
    
    Day: styled.div.attrs({
        className: 'datetabpicker-day'
    })`
    font-weight: 500;
    `,

    Date: styled.div.attrs({
        className: 'datetabpicker-date'
    })`
    font-weight: 300;
    `,

}